import { gql } from '@apollo/client';

// DELETE_TECHNICIAN mutation
export const DELETE_TECHNICIAN = gql`
  mutation DeleteTechnician($id: String!) {
    deleteTechnician(id: $id)
  }
`;

// EDIT_TECHNICIAN_PASSWORD mutation
export const EDIT_TECHNICIAN_PASSWORD = gql`
  mutation EditTechnicianPassword($technicianId: ID!, $newPassword: String!) {
    editTechnicianPassword(input: { technicianId: $technicianId, newPassword: $newPassword })
  }
`;
